import script from "./commentdetails.vue?vue&type=script&setup=true&lang=js"
export * from "./commentdetails.vue?vue&type=script&setup=true&lang=js"

import "../../../styles/van-sticky-nav.css?vue&type=style&index=0&id=33abd4ec&scoped=true&lang=css"
import "./commentdetails.vue?vue&type=style&index=1&id=33abd4ec&scoped=true&lang=css"
import "./commentdetails.vue?vue&type=style&index=2&id=33abd4ec&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33abd4ec"]])

export default __exports__